const INITIAL_STATE = {
    sideBarReducer: { values: [], error: null, loading: false },
  };
  
  export default function (state = INITIAL_STATE, action) {
    return {
      ...state,
      sideBarReducer: { values: action.payload, error: null, loading: true },
    };
  }
  